import { create } from 'zustand';
import { IAppbarStore } from './types';

export const useAppbarStore = create<IAppbarStore>((set) => ({
  sidebarOpen: false as boolean,
  updateAppbarStore: ({ sidebarOpen }: { sidebarOpen: boolean }) => set(() => ({ sidebarOpen: sidebarOpen })),
}));

export default useAppbarStore;
